import axios from "axios";

export default axios.create({
    baseURL:"https://glorious-winner-pjjxwvpqv5pwcxxg-9999.app.github.dev/",
});

